import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  APP_THEME_EVENT,
  nextAppTheme,
  readAppTheme,
  saveAppTheme,
} from "../utils/appTheme";

const THEME_META = {
  light: { icon: "☀", label: "Light" },
  dark: { icon: "☾", label: "Dark" },
  system: { icon: "◐", label: "System" },
};

const AppThemeToggle = ({ compact = false }) => {
  const [preference, setPreference] = useState(readAppTheme);

  useEffect(() => {
    const sync = (event) => setPreference(event?.detail?.preference || readAppTheme());
    window.addEventListener(APP_THEME_EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(APP_THEME_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const meta = THEME_META[preference] || THEME_META.system;
  const handleToggle = () => {
    const next = nextAppTheme(preference);
    setPreference(next);
    saveAppTheme(next);
  };
  return (
    <ThemeButton
      type="button"
      onClick={handleToggle}
      title={`Theme: ${meta.label}. Click to switch.`}
      aria-label={`Theme is ${meta.label}. Switch theme.`}
      $compact={compact}
    >
      <span aria-hidden="true">{meta.icon}</span>
      {!compact && <span>{meta.label}</span>}
    </ThemeButton>
  );
};

const ThemeButton = styled.button`
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  border-radius: 999px;
  min-width: ${({ $compact }) => ($compact ? "34px" : "76px")};
  min-height: 34px;
  padding: ${({ $compact }) => ($compact ? "6px" : "6px 11px")};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
  cursor: pointer;
  &:hover { background: rgba(255, 255, 255, 0.22); }
  &:focus-visible { outline: 2px solid #fff; outline-offset: 2px; }
`;

export default AppThemeToggle;
